import { render, staticRenderFns } from "./finance.vue?vue&type=template&id=4a3e585d&scoped=true&"
import script from "./finance.vue?vue&type=script&lang=ts&"
export * from "./finance.vue?vue&type=script&lang=ts&"
import style0 from "./finance.vue?vue&type=style&index=0&id=4a3e585d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3e585d",
  null
  
)

export default component.exports